"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Slider = exports.SLIDER_STYLE_TYPE = exports.SLIDER_CONTAINER_CLASS_NAME = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _ReactIdSwiper = _interopRequireDefault(require("react-id-swiper/lib/ReactIdSwiper.custom"));
var _getComponentDataAttributes = require("b2b-components/utils/getComponentDataAttributes");
var _server = require("b2b-components/utils/server");
var _upperCase = require("b2b-components/utils/upperCase");
var _classnames = _interopRequireDefault(require("classnames"));
var _swiper = _interopRequireWildcard(require("swiper"));
var _Arrow = require("./Arrow");
require("./Slider.scss");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
if (!_server.isServer) {
  require('swiper/swiper-bundle.min.css');
}
const SLIDER_CONTAINER_CLASS_NAME = exports.SLIDER_CONTAINER_CLASS_NAME = 'cds-Slider-Container';
const SLIDER_NUMBER_PRODUCTS_BOX_NO_NAVIGATION = 4;
let SLIDER_STYLE_TYPE = exports.SLIDER_STYLE_TYPE = /*#__PURE__*/function (SLIDER_STYLE_TYPE) {
  SLIDER_STYLE_TYPE["default"] = "default";
  SLIDER_STYLE_TYPE["withMargin"] = "withMargin";
  return SLIDER_STYLE_TYPE;
}({});
const Slider = _ref => {
  let {
    breakpoints,
    children,
    dataAttributes,
    productBoxCount,
    slidesPerGroup,
    spaceBetween,
    autoplayDelay = 4000,
    isAutoplay = true,
    isAutoplayDisableOnInteraction = true,
    isLoop = true,
    isPagination = false,
    slidesPerView = 1,
    styleType = SLIDER_STYLE_TYPE.default,
    className,
    containerClassName
  } = _ref;
  const rootClassName = (0, _classnames.default)('cds-Slider', className, {
    [`cds-Slider--${(0, _upperCase.upperCaseFirst)(styleType || '')}`]: styleType !== SLIDER_STYLE_TYPE.default,
    'cds-Slider--WithMarginNoNavigationDesktop': styleType === SLIDER_STYLE_TYPE.withMargin && (productBoxCount || 0) <= SLIDER_NUMBER_PRODUCTS_BOX_NO_NAVIGATION
  });
  const swiperElement = (0, _react.useRef)(null);
  const swiper = (0, _react.useRef)(null);
  const isAutoplayRunning = (0, _react.useRef)(null);
  const initTimeout = (0, _react.useRef)(null);
  const setAutoplayStop = () => {
    if (swiper.current && (isAutoplayRunning.current || isAutoplayRunning.current === null)) {
      swiper.current.autoplay.stop();
    }
  };
  const setAutoplayStart = () => {
    if (swiper.current && (isAutoplayRunning.current || isAutoplayRunning.current === null)) {
      swiper.current.autoplay.start();
    }
  };

  // the method is necessary to avoid appearing duplicate slides which are created
  // by Swiper component (they don't have events handler) and protects from clicking duplicate slides
  const setSlidesCorrectly = isTransitionEnd => {
    const swiperInstance = swiper.current;
    if (!swiperInstance) {
      return null;
    }
    const setPointerEventsForActiveSlide = () => {
      if (!swiperInstance) {
        return;
      }
      swiperInstance.slides[swiperInstance.activeIndex].style.pointerEvents = isTransitionEnd ? 'auto' : 'none';
    };

    /*
      if user interacted with slider, autoplay is not start
    */
    const isDisableOnInteraction = isAutoplayDisableOnInteraction && swiperInstance.autoplay && swiperInstance.autoplay.running;
    if (swiperInstance && swiperInstance.isBeginning && swiperInstance.params.loop) {
      isTransitionEnd && swiperInstance.slideToLoop(_react.default.Children.toArray(children).length - 1, 0);
      isAutoplay && isDisableOnInteraction && swiperInstance.autoplay.start();
      setPointerEventsForActiveSlide();
    }
    if (swiperInstance && swiperInstance.isEnd && swiperInstance.params.loop) {
      isTransitionEnd && swiperInstance.slideToLoop(0, 0);
      isAutoplay && isDisableOnInteraction && swiperInstance.autoplay.start();
      setPointerEventsForActiveSlide();
    }
  };
  const setAutoplayRunning = isRunning => {
    isAutoplayRunning.current = isRunning;
  };
  const handleSwiperAutoplay = () => {
    setAutoplayRunning(true);
  };
  const handleSwiperObserverUpdate = () => {
    swiper.current && swiper.current.slideToLoop(0, 0);
  };
  const handleSwiperSlideChangeTransitionEnd = () => {
    setSlidesCorrectly(true);
  };
  const handleSwiperSlideChangeTransitionStart = () => {
    setSlidesCorrectly(false);
  };
  const handleSwiperTouchEnd = () => {
    if (isAutoplayDisableOnInteraction) {
      setAutoplayRunning(false);
    }
  };
  const paginationConfig = {
    pagination: {
      bulletActiveClass: 'cds-Slider-PaginationBullet--Active',
      bulletClass: 'cds-Slider-PaginationBullet',
      clickable: true,
      el: '.cds-Slider-Pagination'
    },
    renderPagination: () => /*#__PURE__*/_react.default.createElement("div", {
      className: "cds-Slider-Pagination"
    })
  };
  const invisiblePaginationConfig = {
    ...paginationConfig,
    pagination: {
      ...paginationConfig.pagination,
      bulletClass: 'cds-Slider-PaginationBullet--Invisible'
    }
  };
  const swiperParams = {
    ...(isPagination ? paginationConfig : invisiblePaginationConfig),
    ...(isAutoplay && {
      autoplay: {
        delay: autoplayDelay,
        disableOnInteraction: isAutoplayDisableOnInteraction
      }
    }),
    ...(isLoop && {
      loop: isLoop
    }),
    ...(spaceBetween && {
      spaceBetween
    }),
    ...(slidesPerView && {
      slidesPerView
    }),
    ...(slidesPerGroup && {
      slidesPerGroup
    }),
    ...(breakpoints && {
      breakpoints
    }),
    centerInsufficientSlides: true,
    containerClass: (0, _classnames.default)(SLIDER_CONTAINER_CLASS_NAME, containerClassName),
    modules: [_swiper.Autoplay, _swiper.Navigation, _swiper.Pagination],
    navigation: {
      disabledClass: _Arrow.ARROW_DISABLED_CLASS_NAME,
      nextEl: `.${_Arrow.ARROW_TYPE_CLASS_NAME[_Arrow.ARROW_TYPE.next]}`,
      prevEl: `.${_Arrow.ARROW_TYPE_CLASS_NAME[_Arrow.ARROW_TYPE.prev]}`
    },
    observer: true,
    on: {
      autoplay: handleSwiperAutoplay,
      observerUpdate: handleSwiperObserverUpdate,
      slideChangeTransitionEnd: handleSwiperSlideChangeTransitionEnd,
      slideChangeTransitionStart: handleSwiperSlideChangeTransitionStart,
      touchEnd: handleSwiperTouchEnd
    },
    renderNextButton: () => /*#__PURE__*/_react.default.createElement(_Arrow.Arrow, {
      type: _Arrow.ARROW_TYPE.next
    }),
    renderPrevButton: () => /*#__PURE__*/_react.default.createElement(_Arrow.Arrow, {
      type: _Arrow.ARROW_TYPE.prev
    }),
    Swiper: _swiper.default,
    threshold: 10,
    watchOverflow: true
  };
  (0, _react.useEffect)(() => {
    if (initTimeout.current) {
      clearTimeout(initTimeout.current);
    }
    initTimeout.current = setTimeout(() => {
      const swiperInstance = swiperElement.current && swiperElement.current.swiper;
      if (!swiper.current) {
        swiper.current = swiperInstance;
      }
    }, 0);
    return () => {
      if (initTimeout.current) {
        clearTimeout(initTimeout.current);
      }
    };
  });
  (0, _react.useEffect)(() => {
    if (swiper.current && isAutoplay) {
      swiper.current.el.addEventListener('mouseenter', setAutoplayStop);
      swiper.current.el.addEventListener('mouseleave', setAutoplayStart);
      return () => {
        swiper.current.el.removeEventListener('mouseenter', setAutoplayStop);
        swiper.current.el.removeEventListener('mouseleave', setAutoplayStart);
      };
    }
  });
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, (0, _getComponentDataAttributes.getComponentDataAttributes)(dataAttributes), {
    className: rootClassName
  }), /*#__PURE__*/_react.default.createElement(_ReactIdSwiper.default, (0, _extends2.default)({}, swiperParams, {
    ref: swiperElement
  }), children));
};
exports.Slider = Slider;
//# sourceMappingURL=Slider.js.map